//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data(){
        return{
            active: 'one',
            more:false,
            show:false,

            permissions:false,
        }
    },
    mounted(){
        
    },
    methods:{
        onChangetab(i){
            if(i == 1){
                this.active = 'one'
                this.$emit('changeTab',1)
            }
            if(i == 2){
                this.active = 'two'
                this.$emit('changeTab',2)
            }
            if(i == 3){
                this.active = 'three'
                this.$emit('changeTab',3)
            }
            if(i == 4){
                this.active = 'four'
                this.$emit('changeTab',4)
            }
        },
        onMore(){
            let role = sessionStorage.getItem('role')
            if(role == 1){  //系统管理员
                this.permissions = true
            }else if(role == 2){  // 管理员
                this.permissions = true
            }else{  // 生产人员
                this.permissions = false
            }
            if(!this.permissions){
                this.$toast.fail('你没有该权限')
                return
            }
            this.more = !this.more
            if(this.more){
                this.show = true
            }else{
                this.show = false
            }
        },
        onClose(){
            this.more = false
        },


        // 新建工单
        onWork(){
            this.show = false
            setTimeout(() => {
                this.$router.push({
                    path:'/newWorkOrder',
                })
            }, 200);
        },
        // 入库单
        onEntry(){
            this.show = false
            setTimeout(() => {
                this.$router.push({
                    path:'/warehouseEntry',
                })
            }, 200);
        },
        // 出库单
        onExit(){
            this.show = false
            setTimeout(() => {
                this.$router.push({
                    path:'/warehouseOrder',
                })
            }, 200);
        },
        // 现有库存
        onInventory(){
            this.show = false
            setTimeout(() => {
                this.$router.push({
                    path:'/stockQuantity',
                })
            }, 200);
        },
        // 产品数据
        onProduct(){
            this.show = false
            setTimeout(() => {
                this.$router.push({
                    path:'/productData',
                })
            }, 200);
        },
        // 产品单位
        onUnit(){
            this.show = false
            setTimeout(() => {
                this.$router.push({
                    path:'/unit',
                })
            }, 200);
        },
        // 不良品项
        onDefectives(){
            this.show = false
            setTimeout(() => {
                this.$router.push({
                    path:'/defectives',
                })
            }, 200);
        },
        // 绩效工资
        onAllocation(){
            this.show = false
            setTimeout(() => {
                this.$router.push({
                    path:'/allocation',
                })
            }, 200);
        },
        // 生产报表
        onReport(){
            this.show = false
            setTimeout(() => {
                this.$router.push({
                    path:'/productionReport',
                })
            }, 200);
        },
        // 客户列表
        onCustomer(){
            this.show = false
            setTimeout(() => {
                this.$router.push({
                    path:'/customerList',
                })
            }, 200);
        },
        // 供应商
        onSupplier(){
            this.show = false
            setTimeout(() => {
                this.$router.push({
                    path:'/suppliers',
                })
            }, 200);
        },



        // 工单
        onOrder(){
            this.show = false
            setTimeout(() => {
                this.onChangetab(1)
            }, 200);
        },
        // 任务
        onTask(){
            this.show = false
            setTimeout(() => {
                this.onChangetab(2)
            }, 200);
        },
        // 报工
        onSubmit(){
            this.show = false
            setTimeout(() => {
                this.onChangetab(3)
            }, 200);
        },
        // 个人
        onUser(){
            this.show = false
            setTimeout(() => {
                this.onChangetab(4)
            }, 200);
        },

    },
}



// WEBPACK FOOTER //
// ./src/components/home/tabbar.vue